import Header from './Compartido/Header.jsx';
import Footer from './Compartido/Footer.jsx';
import BtnFloating from './Compartido/BtnFloating.jsx';
import Widget from './Recomendaciones/Widget.jsx';
import Intro from './Recomendaciones/Intro.jsx';
import Content from './Recomendaciones/Content.jsx';
import Scripts from './Compartido/Scripts.jsx';

import '../../../../../resources/css/web/holidayhomescanarias/header.css'
import '../../../../../resources/css/web/holidayhomescanarias/general.css';
import '../../../../../resources/css/web/holidayhomescanarias/footer.css'
import '../../../../../resources/css/web/holidayhomescanarias/buttons.css'
import '../../../../../resources/css/web/holidayhomescanarias/intro.css'

const Clientes = (props) => {
    return (
        <main>
            <Header
                datos={props.websgrupo}
                lang={props.lang}
                idiomas={props.idiomas}
                tipo="inicio"
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
            />
            <Intro
                lang={props.lang}
                ruta={props.ruta}
                clientes={props.textoclientes}
            />
            <Content
                lang={props.lang}
                clientes={props.textoclientes}
            />
            <Widget
                lang={props.lang}
            />
            <Footer
                lang={props.lang}
                config={props.config}
            />
            <BtnFloating />

            <Scripts />
        </main>
    );
}

export default Clientes;

